import { Button } from "primereact/button";
import { Route } from 'react-router-dom'

const ButtonRetrocederQuestionario = ({ etapa, handleAvancarEtapaGrupoQuestao, handleSetEtapaQuestionario }) => {

    let buttonRetroceder;

    if (etapa === "I") {
        buttonRetroceder = (
            <Route render={(props) => (
                <Button className="p-button-danger" label="RETROCEDER" icon="pi pi-arrow-left" onClick={() => {
                    props.history.goBack();
                }} />
            )} />
        );

    } else if (etapa === "Q") {
        buttonRetroceder = (
            <Button className="p-button-danger" label="RETROCEDER" icon="pi pi-arrow-left" onClick={() => { handleAvancarEtapaGrupoQuestao(-1) }} />
        );

    } else {
        buttonRetroceder = (
            <Button className="p-button-danger" label="RETROCEDER" icon="pi pi-arrow-left" onClick={() => { handleSetEtapaQuestionario(-1) }} />
        );
    }

    return (
        <div>
            {buttonRetroceder}
        </div>

    )
}

export default ButtonRetrocederQuestionario